
export default function getResource(label, vars = []) {
    const resources = {
        oosAlternateLinkLegend: 'Sélectionner une autre option'
    };

    return resources[label];
}
